import { EEC_API_BASE_PATH } from '../shared-api';

export const BASE_PATH = EEC_API_BASE_PATH;

export const SGKC_API_COLLECTION_FORMATS = {
    'csv': ',',
    'tsv': '   ',
    'ssv': ' ',
    'pipes': '|'
}